import { v4 as uuidv4 } from "uuid";
export class AutomationHistoryModel {
    constructor() {
        this.id = uuidv4();
        this.recurrenceRule = "";
        this.organizationName = "";
        this.name = "";
        this.savedSearchName = "";
        this.recurrenceStartDateAsString = "";
        this.logs = [];
    }
}
export default class AutomationHistory extends AutomationHistoryModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
